import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as dat from "lil-gui";

window.startCanvas = () => {
  /**
   * Base
   */
  // Debug
  const gui = new dat.GUI();

  // Canvas
  const canvas = document.getElementById("webgl");

  //Audio
  const audio = window.amenoAudio;

  // Scene
  const scene = new THREE.Scene();

  /**
   * Lights
   */

  // Ambient light
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.0);
  gui
    .add(ambientLight, "intensity")
    .min(0)
    .max(1)
    .step(0.001)
    .name("ambient light intensity");
  scene.add(ambientLight);

  const spotLights = [];

  const spotLightIntensity = 1;

  const calculateSpotLightIntensity = (base, time, index) => {
    return base + Math.cos(time + index * 1.5);
  };

  const makeSpotLight = (number, color, x, y, z) => {
    // Spot light
    const spotLight = new THREE.SpotLight(
      color,
      calculateSpotLightIntensity(spotLightIntensity, 0, number),
      10,
      Math.PI * 0.28
    );

    gui
      .addColor(spotLight, "color")
      .onChange((color) => (spotLight.color = new THREE.Color(color)))
      .name("color " + number);

    gui
      .add(spotLight, "intensity")
      .min(0)
      .max(1)
      .step(0.001)
      .name("spot light" + number + " intensity");

    spotLight.castShadow = true;

    spotLight.shadow.mapSize.width = 1024;
    spotLight.shadow.mapSize.height = 1024;

    spotLight.shadow.camera.near = 1;
    spotLight.shadow.camera.far = 6;

    spotLight.shadow.camera.fov = 30;

    spotLight.position.set(x, y, z);

    gui
      .add(spotLight.position, "x")
      .min(-10)
      .max(10)
      .step(1)
      .name("spot light" + number + " position x");

    gui
      .add(spotLight.position, "y")
      .min(-10)
      .max(10)
      .step(1)
      .name("spot light" + number + " position y");

    gui
      .add(spotLight.position, "z")
      .min(-10)
      .max(10)
      .step(1)
      .name("spot light" + number + " position z");

    scene.add(spotLight);
    scene.add(spotLight.target);

    const spotLightCameraHelper = new THREE.CameraHelper(
      spotLight.shadow.camera
    );
    spotLightCameraHelper.visible = false;

    const spotLightHelper = new THREE.SpotLightHelper(spotLight);
    spotLightHelper.visible = false;
    scene.add(spotLightHelper);

    scene.add(spotLightCameraHelper);

    return spotLight;
  };

  spotLights.push(makeSpotLight(0, "#56e3f5", 0, 2, 4));

  spotLights.push(makeSpotLight(1, "#bb0feb", 4, 2, 0));

  spotLights.push(makeSpotLight(2, "#f90b6a", -4, 2, 0));

  spotLights.push(makeSpotLight(3, "#5a8cf2", 0, 2, -4));

  /**
   * Materials
   */
  const material = new THREE.MeshStandardMaterial();
  material.roughness = 0.2;
  gui.add(material, "metalness").min(0).max(1).step(0.001);
  gui.add(material, "roughness").min(0).max(1).step(0.001);

  /**
   * Objects
   */
  const makeSpheres = (count) => {
    return new Array(count).fill("").map(() => {
      const sphere = new THREE.Mesh(
        new THREE.SphereGeometry(0.2, 32, 32),
        material
      );
      sphere.castShadow = true;
      scene.add(sphere);
      return sphere;
    });
  };

  const spheres = makeSpheres(5);

  const plane = new THREE.Mesh(new THREE.PlaneGeometry(10, 10), material);
  plane.receiveShadow = true;
  plane.rotation.x = -Math.PI * 0.5;
  plane.position.y = -0.2;

  scene.add(plane);

  /**
   * Sizes
   */
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  window.addEventListener("resize", () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  });

  /**
   * Camera
   */
  // Base camera
  const camera = new THREE.PerspectiveCamera(
    75,
    sizes.width / sizes.height,
    0.1,
    100
  );
  camera.position.x = 1;
  camera.position.y = 1;
  camera.position.z = 2;
  scene.add(camera);

  // Controls
  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;

  /**
   * Renderer
   */
  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
  });
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  /**
   * Animate
   */
  const clock = new THREE.Clock();
  clock.stop();

  audio.addEventListener("play", () => {
    // gsap.to(camera.position, { duration: 2, x: 3 });
    // gsap.to(camera.position, { delay: 8, duration: 2, x: 2, z: -2 });
    // gsap.to(camera.position, { delay: 13, duration: 3, x: -1, z: -3 });
    // gsap.to(camera.position, { delay: 18, duration: 2, y: 2, x: -2, z: -2 });
    clock.start();
  });

  const movingParams = { radius: 1.5, speed: 0.45 };

  gui.add(movingParams, "radius").min(0).max(3).step(0.001).name("radius");
  gui.add(movingParams, "speed").min(0).max(3).step(0.001).name("speed");

  const dancingPoint1 = 3.57;
  const dancingPoint2 = 17.6;
  const dancingPoint3 = 37;

  const lightPoint1 = 8;
  const lightPoint2 = 28;

  const endPoint = 36;

  const tick = () => {
    const elapsedTime = clock.getElapsedTime();

    // Update the sphere
    spheres.forEach((sphere, index) => {
      const positionDelta = Math.PI * 2 * (index / spheres.length);
      if (!elapsedTime) {
        return;
      }

      if (elapsedTime <= dancingPoint1) {
        sphere.position.x =
          Math.cos(dancingPoint1 * movingParams.speed + positionDelta) *
          movingParams.radius *
          (elapsedTime / dancingPoint1);
        sphere.position.z =
          Math.sin(dancingPoint1 * movingParams.speed + positionDelta) *
          movingParams.radius *
          (elapsedTime / dancingPoint1);
      } else if (elapsedTime <= dancingPoint2) {
        sphere.position.x =
          Math.cos(elapsedTime * movingParams.speed + positionDelta) *
          movingParams.radius;

        sphere.position.z =
          Math.sin(elapsedTime * movingParams.speed + positionDelta) *
          movingParams.radius;
      } else if (elapsedTime <= dancingPoint3) {
        movingParams.radius = 1.5 - Math.sin(elapsedTime - dancingPoint2);

        sphere.position.x =
          Math.cos(elapsedTime * movingParams.speed + positionDelta) *
          movingParams.radius;

        sphere.position.z =
          Math.sin(elapsedTime * movingParams.speed + positionDelta) *
          movingParams.radius;
      }
    });

    //Update lights

    spotLights.forEach((light, index) => {
      if (elapsedTime >= lightPoint1) {
        light.intensity = calculateSpotLightIntensity(
          spotLightIntensity,
          elapsedTime - lightPoint1,
          index
        );
      }
      if (elapsedTime >= lightPoint2) {
        const timeFromStart = elapsedTime - lightPoint2;
        const timeToEnd = endPoint - lightPoint2;
        const downK = 1 - timeFromStart / timeToEnd;
        light.intensity = light.intensity * downK;
      }
    });

    // Update controls
    controls.update();

    // Render
    renderer.render(scene, camera);

    // Call tick again on the next frame
    window.requestAnimationFrame(tick);
  };

  gui.hide();

  tick();
};

window.loadMusic = () => {
  const request = new XMLHttpRequest();
  request.open("GET", "./ameno.mp3", true);
  request.responseType = "blob";

  const button = document.getElementById("button");
  button.style.display = "none";

  const loader = document.getElementById("loader");
  loader.style.display = "block";

  request.onload = function () {
    if (this.status == 200) {
      const audio = new Audio(URL.createObjectURL(this.response));
      window.amenoAudio = audio;
      audio.load();
      const canvas = document.getElementById("webgl");
      canvas.style.display = "block";

      const container = document.getElementById("button-container");
      container.style.display = "none";

      loader.style.display = "none";

      window.startCanvas();
      setTimeout(() => {
        audio.play();
      });
    }
  };
  request.send();
};
